import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  input_file_path: '',
  output_file_path: '',
  model_id: 'whisperx-large-v3',
  language: '',
  diarization: false,
  format: 'json',
};

export const transcriptionSlice = createSlice({
  name: 'transcription',
  initialState,
  reducers: {
    updateData(state, action) {
      state.input_file_path = action.payload.input_file_path;
      state.output_file_path = action.payload.output_file_path;
      state.model_id = action.payload.model_id;
      state.language = action.payload.language;
      state.diarization = action.payload.diarization;
      state.format = action.payload.format;
    },
  },
});

export const { updateData } = transcriptionSlice.actions;
export default transcriptionSlice.reducer;
